<template>
  <div>
    <v-row class="my-0">
      <v-col
        v-for="(columnCards, columnIndex) in invoiceCardColumns"
        :key="`invoice-column-${columnIndex}`"
        cols="12"
        md="6"
        xl="4"
        class="py-0 mb-8 pr-xl-5"
      >
        <HeadingBox
          v-for="card in columnCards"
          :key="card.id"
          icon="mdi-alpha-e-box"
          :title="card.title"
          :loading="loading"
          class="mb-6"
        >
          <OverviewInvoicesUpload v-if="card.id === 'invoices'" :visitItem="visitItem" @updateInvoices="setInvoices($event)"/>
          <template v-if="getLogItems(card.id).length > 0">
            <div v-for="(logItem, logIndex) in getLogItems(card.id)" :key="`${card.id}-${logItem['id'] || logItem['visitLogId'] || logItem['createDate'] || ''}-${logIndex}`" class="mb-2">
              <div class="d-flex flex-nowrap align-center">
                <v-tooltip bottom :allow-overflow="true">
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon v-bind="attrs" v-on="on" size="20" class="mr-2">mdi-alpha-e-box</v-icon>
                  </template>
                  <span>{{ card.tooltip }}</span>
                </v-tooltip>
                <v-tooltip bottom :allow-overflow="true">
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon v-bind="attrs" v-on="on" size="20" :class="['mr-4', logStatusIconColor(logItem['status'])]">{{ logStatusIconName(logItem['status']) }}</v-icon>
                  </template>
                  <span>{{ logStatusText(logItem['status']) }}</span>
                </v-tooltip>
                <span class="text-body-1 mr-4 text-no-wrap">{{ formattedDate(logItem['sendDate']) }}</span>
              </div>
              <div v-if="(logItem['eboksMessageAttachments'] || []).length > 0" class="d-flex justify-end">
                <EboksAttachment
                  v-for="attachment in (logItem['eboksMessageAttachments'] || [])"
                  :key="`${card.id}-${logItem['id'] || logItem['visitLogId'] || logItem['createDate']}-${attachment['type']}-${attachment['id']}`"
                  :visit-id="visitItem.id"
                  :attachment-id="attachment['id']"
                  :attachment-type="attachment['type']"
                />
              </div>
            </div>
          </template>
          <span v-else class="d-block text-body-1 grey--text">Ingen data...</span>
        </HeadingBox>
      </v-col>
    </v-row>
  </div>
</template>

<script>
  import HeadingBox from '@/components/common/HeadingBox.vue';
  import EboksAttachment from '@/components/common/EboksAttachment.vue';
  import api from '@/api/api';
  import logStatusIconMixin from '@/mixins/logStatusIconMixin';
  import methods from '@/utils/methods';
  import OverviewInvoicesUpload from '@/components/overview/OverviewInvoicesUpload.vue';

  export default {
    name: 'OverviewEBoksInvoices',
    components: {OverviewInvoicesUpload, HeadingBox, EboksAttachment},
    mixins: [logStatusIconMixin],

    props: {
      visitItem: {
        type: Object,
      },
    },

    data: function () {
      return {
        loading: false,
        invoicesLogs: [],
        offersLogs: [],
        receiptsLogs: [],
        remindersLogs: [],
        diverseLogs: [],
      };
    },

    computed: {
      invoiceCards: function () {
        return [
          {id: 'invoices', title: 'Fakturaer', tooltip: 'e-Boks Faktura'},
          {id: 'offers', title: 'Overslag', tooltip: 'e-Boks Overslag'},
          {id: 'receipts', title: 'Kvittering', tooltip: 'e-Boks Kvittering'},
          {id: 'reminders', title: 'Rykker', tooltip: 'e-Boks Rykker'},
          {id: 'diverse', title: 'Diverse', tooltip: 'e-Boks Diverse'},
        ];
      },
      invoiceCardColumns: function () {
        return [
          [this.invoiceCards[0]],
          [this.invoiceCards[1], this.invoiceCards[2]],
          [this.invoiceCards[3], this.invoiceCards[4]],
        ];
      },
    },

    mounted: async function () {
      this.getInvoicesLogs();
    },

    methods: {
      formattedDate: function (value) {
        if (value) {
          return`${methods.getDateFromIso(value)}, ${methods.getTimeFromIso(value)}`;
        }
        return 'Afsendelse planlagt..';
      },
      setInvoices: function (invoicesData) {
        this.invoicesLogs = invoicesData.data?.invoices || [];
        this.offersLogs = invoicesData.data?.offers || [];
        this.receiptsLogs = invoicesData.data?.receipts || [];
        this.remindersLogs = invoicesData.data?.reminders || [];
        this.diverseLogs = invoicesData.data?.diverse || [];
      },
      getLogItems: function (type) {
        return {
          invoices: this.invoicesLogs,
          offers: this.offersLogs,
          receipts: this.receiptsLogs,
          reminders: this.remindersLogs,
          diverse: this.diverseLogs,
        }[type] || [];
      },
      getInvoicesLogs: async function () {
        try {
          this.loading = true;
          let invoicesData = await api.getInvoices(this.visitItem.id);
          this.setInvoices(invoicesData);
        } finally {
          this.loading = false;
        }
      }
    }
  };
</script>
